"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMenu = exports.NavigationMenuSpacer = exports.NavigationMenuHeader = exports.NavigationMenuItem = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var mobile_1 = require("../../utils/mobile");
var components_1 = require("./components");
Object.defineProperty(exports, "NavigationMenuItem", { enumerable: true, get: function () { return components_1.NavigationMenuItem; } });
Object.defineProperty(exports, "NavigationMenuHeader", { enumerable: true, get: function () { return components_1.NavigationMenuHeader; } });
Object.defineProperty(exports, "NavigationMenuSpacer", { enumerable: true, get: function () { return components_1.NavigationMenuSpacer; } });
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('NavigationMenu'), (0, recompose_1.defaultProps)({
    isOpen: false,
    isShrunk: false
}));
exports.NavigationMenu = enhance(function (props) {
    if (props.isShrunk) {
        document.body.classList.add('navigation-menu-shurnk');
    }
    else {
        document.body.classList.remove('navigation-menu-shurnk');
    }
    if (props.isOpen) {
        document.body.classList.add('navigation-menu-open');
    }
    else {
        document.body.classList.remove('navigation-menu-open');
    }
    return (React.createElement("div", { className: classNames(props.className, 'sok-navigation-menu', {
            shrunk: props.isShrunk,
            open: props.isOpen,
            mobile: mobile_1.isMobile
        }), style: props.style, onClick: function () {
            if (props.onClose) {
                props.onClose();
            }
        } },
        React.createElement("div", { className: "sok-navigation-menu-inner" }, props.children)));
});
//# sourceMappingURL=index.js.map